import React from 'react';
import ModuleShell from '@/components/layout/ModuleShell';
import { useAuth } from '@/contexts/AuthContext';
import EntitySearchPage from '@/pages/EntitySearchPage';
import SubmissionsPage from '@/pages/SubmissionsPage';
import ClassSubmissionPage from '@/pages/ClassSubmissionPage';
import DocumentUploadPage from '@/pages/DocumentUploadPage';
import QuotePipelineAnalyticsPage from '@/pages/QuotePipelineAnalyticsPage';
import MultiClassSubmissionPage from '@/pages/MultiClassSubmissionPage';

export default function NewBusinessModule() {
  const { user } = useAuth();
  const isStaff = user?.role !== 'broker';
  const tabs = [
    { id: 'pipeline', label: 'Pipeline', content: <SubmissionsPage /> },
    { id: 'upload', label: 'Upload', content: <DocumentUploadPage /> },
    { id: 'submit', label: 'New Submission', content: <EntitySearchPage /> },
    { id: 'quote', label: 'Quote & Bind', content: <ClassSubmissionPage /> },
    { id: 'package', label: 'Multi-Class', content: <MultiClassSubmissionPage /> },
    ...(isStaff ? [{ id: 'analytics', label: 'Analytics', content: <QuotePipelineAnalyticsPage /> }] : []),
  ];

  return (
    <ModuleShell title="New Business" subtitle="Submission to bound policy" tabs={tabs} />
  );
}
